import { MessageResponseDto } from "@api/api";
import { getFormErrorMessage } from "@core/utility/get-error-message";
import { packageActivityFormDefault } from "@factory/form/form.default";
import { PackageActivityFormRule, PackageActivityFormSchema } from "@factory/form/form.rule";
import { useQyCreatePackageActivity } from "@factory/query/package-activity.query";
import { useFormApiMapper } from "@factory/services/form-api-mapper.hook";
import { zodResolver } from "@hookform/resolvers/zod";
import { useNotificationContext } from "@shared/ui/notification/notification.context";
import { FieldErrors, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";

export function useNewPackageActivity() {
 // LOCAL DECLARATION
  const navigate = useNavigate();
  const { mapCreatePackageActivity } = useFormApiMapper();
  const { showError, showSuccess, showWarning } = useNotificationContext();

  // QUERIES
  const handleApiSuccess = (response: MessageResponseDto) => {
    const data = response.data as any;

    showSuccess(`New PackageActivity is created`);
    navigate(`../${data.code}`);
  };
  const { mutate: addPackageActivity, isLoading: isCreating } =
    useQyCreatePackageActivity(handleApiSuccess);

  // LOCAL FUNCTIONS
  const formMethod = useForm<PackageActivityFormSchema>({
    defaultValues: packageActivityFormDefault,
    resolver: zodResolver(PackageActivityFormRule),
  });
  const { handleSubmit } = formMethod;

  const handleValidate = (form: PackageActivityFormSchema) => {
    const formData = mapCreatePackageActivity(form);
    addPackageActivity(formData);
  };
  const handleValidateError = (err: FieldErrors<PackageActivityFormSchema>) => {
    const formMessage = getFormErrorMessage(err);
    showError(formMessage);
  };

  return {
    isCreating,
    formMethod,
    navigate,
    handleSubmit,
    handleValidate,
    handleValidateError,
  };
}
